export const KEY = 'vuex';
